/**
 * Explore Unknown postcard collection (portal gallery).
 * Image files: React/public/postcards/<missionIndex>.jpg
 *
 * Must match `EXPLORE_UNKNOWN_AUTHORED_MISSION_COUNT` in modules/exploreUnknownMissions.js
 * (currently 75 — Shadow Negara / HUMANITY finale). `MISSION_COUNT` (100) is only the XP cap.
 */

export const EXPLORE_UNKNOWN_POSTCARD_MISSION_COUNT = 75;

/** Shipped art exists for every authored mission index (1…75). */
export const EXPLORE_UNKNOWN_POSTCARD_IMAGE_AVAILABLE_INDICES = Object.freeze(
  Array.from({ length: EXPLORE_UNKNOWN_POSTCARD_MISSION_COUNT }, (_, i) => i + 1)
);

/**
 * @param {number} missionIndex
 * @returns {boolean}
 */
export function isExploreUnknownPostcardImageAvailable(missionIndex) {
  if (!Number.isInteger(missionIndex)) {
    throw new Error(`isExploreUnknownPostcardImageAvailable: missionIndex must be an integer (${missionIndex})`);
  }
  return missionIndex >= 1 && missionIndex <= EXPLORE_UNKNOWN_POSTCARD_MISSION_COUNT;
}

/**
 * @param {number} missionIndex
 * @returns {string | null} Root-relative URL when art exists; null when not yet authored.
 */
export function getExploreUnknownPostcardImageUrl(missionIndex) {
  if (!isExploreUnknownPostcardImageAvailable(missionIndex)) {
    return null;
  }
  return `/postcards/${missionIndex}.jpg`;
}

/**
 * Portal button thumbnail: newest earned mission that has shipped art, else first available asset.
 * @param {number[]} earnedMissionIndices
 * @returns {number}
 */
export function resolveExploreUnknownPostcardPreviewMissionIndex(earnedMissionIndices) {
  if (!Array.isArray(earnedMissionIndices)) {
    throw new Error(
      'resolveExploreUnknownPostcardPreviewMissionIndex: earnedMissionIndices must be an array'
    );
  }
  const earnedWithArt = earnedMissionIndices
    .filter((idx) => Number.isInteger(idx) && getExploreUnknownPostcardImageUrl(idx) != null)
    .sort((a, b) => a - b);
  if (earnedWithArt.length > 0) {
    return earnedWithArt[earnedWithArt.length - 1];
  }
  return 1;
}
